import { useState, useMemo, useEffect } from 'react'
import { useAppDispatch } from '@/store/hooks'
import { updateLabelSaga } from '@/store/workspace/workspaceSlice'
import { debounce } from '@/utils/debounce'
import { DEBOUNCE_INPUT_TIME } from '@/const/config'
import Input from '@/components/ui/Input/Input'

interface LabelNameInputProps {
    labelId: string
    name: string
}

const LabelNameInput = ({ labelId, name }: LabelNameInputProps) => {
    const dispatch = useAppDispatch()
    const [value, setValue] = useState(name)

    useEffect(() => { setValue(name) }, [name])

    const debouncedSave = useMemo(() => debounce((newName: string) => {
        dispatch(updateLabelSaga({ labelId, data: { name: newName } }))
    }, DEBOUNCE_INPUT_TIME), [dispatch, labelId])

    useEffect(() => () => debouncedSave.cancel(), [debouncedSave])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        setValue(newValue)
        if (newValue.trim()) {
            debouncedSave(newValue.trim())
        }
    }

    return <Input value={value} onChange={handleChange} />
}

export default LabelNameInput
